import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription, takeUntil } from 'rxjs';
import { KbDataExtractionRequestService } from 'src/app/services/feature/data-extraction-request/kb-data-extraction-request.service';

@Component({
  selector: 'app-kb-data-extraction-request-left-side-navigation',
  templateUrl: './kb-data-extraction-request-left-side-navigation.component.html',
  styleUrl: './kb-data-extraction-request-left-side-navigation.component.scss',
  standalone: false,
})
export class KbDataExtractionRequestLeftSideNavigationComponent {
  currentComponent: string;
  isMobile: boolean;
  iconToggler: boolean = true;

  private dataExtractionService = inject(KbDataExtractionRequestService);
  private cdr = inject(ChangeDetectorRef);
  private BreakpointObserver = inject(BreakpointObserver)

  private subscription = new Subscription();
  constructor() {
    this.subscription.add(
      this.BreakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe(result => {
          this.isMobile = result.matches;
        })
    );
  }
  ngOnInit() {

    this.subscription.add(this.dataExtractionService.currentComponent$.subscribe(x => {
      if (x != null) {
        this.currentComponent = x;
      } else {
        this.currentComponent = 'dataExtractionOverview';
      }
      this.cdr.detectChanges();
    }));
  }
  SelectedComponent(componentName, event) {
    event.preventDefault();
    this.subscription.add(
      this.dataExtractionService.nextComponentClick$.subscribe(x => {
        if (x) {
          this.dataExtractionService.currentComponent$.next(componentName);
        } else {
          componentName = 'dataExtractionOverview';
        }
      }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
